import { render } from "./PrivacyCookies.vue?vue&type=template&id=50cbb972"
import script from "./PrivacyCookies.vue?vue&type=script&lang=js"
export * from "./PrivacyCookies.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__